import { getToken, onMessage, getMessagingInstance } from './firebase';

export const requestNotificationPermission =
  async (): Promise<NotificationPermission> => {
    if (!('Notification' in window)) {
      throw new Error('This browser does not support notifications');
    }

    return await Notification.requestPermission();
  };

export const getFCMToken = async (): Promise<string> => {
  const permission = await requestNotificationPermission();

  if (permission !== 'granted') {
    throw new Error('Notification permission not granted');
  }

  const messaging = await getMessagingInstance();

  if (!messaging) {
    throw new Error('Firebase messaging is not supported in this browser');
  }

  try {
    const currentToken = await getToken(messaging, {
      vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
    });

    if (currentToken) {
      return currentToken;
    } else {
      throw new Error('No registration token available');
    }
  } catch (error) {
    console.error('An error occurred while retrieving token:', error);
    throw error;
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    getMessagingInstance().then((messaging) => {
      if (!messaging) {
        resolve(null);
        return;
      }

      onMessage(messaging, (payload) => {
        resolve(payload);
      });
    });
  });
